import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePhoneVerifyTokenMutation, useResendPhoneVerificationMutation } from '../../redux/api/authApi';
import MetaData from '../layout/MetaData';
import toast from 'react-hot-toast';

const PhoneVerify = () => {
  const navigate = useNavigate();
  const [value, setValue] = useState('');
  const [phoneNo] = useState(localStorage.getItem('phoneNo') || '');

  const [phoneVerifyToken, { isLoading, error, isSuccess }] = usePhoneVerifyTokenMutation();
  const [resendPhoneVerification, { isLoading: isResending }] = useResendPhoneVerificationMutation();

  useEffect(() => {
    if (error) toast.error(error?.data?.message);
    if (isSuccess) {
      toast.success('Phone Number Verified successfully');
      navigate('/login');
    }
  }, [error, isSuccess, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await phoneVerifyToken({ code: value });
  };

  const handleResend = async () => {
    if (!phoneNo) {
      toast.error('Phone number missing. Please log in again.');
      return;
    }
    try {
      await resendPhoneVerification({ phoneNo }).unwrap();
      toast.success(`OTP resent successfully to ${phoneNo}`);
    } catch (err) {
      toast.error(err?.data?.message || 'Failed to resend OTP');
    }
  };

  return (
    <>
      <MetaData title="Phone Verification" />
      <div className="row wrapper">
        <div className="col-10 col-lg-5">
          <form className="shadow rounded bg-body" onSubmit={handleSubmit}>
            <h2 className="mb-4 text-center">Phone Verification</h2>

            <div className="mb-3">
              <label htmlFor="value_field" className="form-label">Verification Code</label>
              <input
                type="text"
                id="value_field"
                className="form-control"
                name="value"
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="Enter 6-digit OTP"
                maxLength={6}
                required
              />
            </div>

            <button id="login_button" type="submit" className="btn btn-primary w-100 py-2" disabled={isLoading}>
              {isLoading ? 'Verifying...' : 'Verify Phone'}
            </button>

            <div className="text-center mt-4">
              <button type="button" className="btn btn-outline-primary w-100 py-2" onClick={handleResend} disabled={isResending}>
                {isResending ? 'Resending OTP...' : 'Resend OTP'}
              </button>
            </div>

            <div className="text-center mt-4">
              <Link to="/login">Back to Login</Link>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PhoneVerify;